define('viewmodels/survey/QuantitativeSurveySetup',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/app', 'durandal/system', 'services/appsecurity', 'viewmodels/GeneralSettings', 'viewmodels/survey/ConfigureSurvey'], function (ko, router, navigation, logger, app, system, appsecurity, ObjGeneralSettings, ConfigureSurvey) {
    var title = '';

    var HmViewModel = {
        activate: activate,
        attached: attached,
        detached: detached,
        title: title,
        selectAllMappingFlag: ko.observable(false),
       // allselect: ko.observable(false),
        appsecurity: appsecurity,
        addPopUpCss: ko.observable(true),
        editPopUpCss: ko.observable(true),
        EditAreaVisible: ko.observable(false),
        EditFactorVisible: ko.observable(false),
        EditSubFactorVisible: ko.observable(false),
        CurrentRiskFactorType: ko.observable(),
        SubFactorAssessmentTypeList: ko.observableArray([]),
        SelectedAssessmentTypeSubFactor: ko.observable(),
        RiskAreaSortOrder: ko.observable(),
        RiskFactorSortOrder: ko.observable(),
        RiskSubFactorSortOrder: ko.observable(),
        RiskAreaId: ko.observable(),
        popUpTitle: ko.observable(),
        editableRiskArea: ko.observable(),
        RiskFactorList: ko.observableArray(),
        SelectedRiskAreaDetails: ko.observableArray(),
        SurveyDetailsList: ko.observableArray(),
        RiskAreaList: ko.observableArray(),
        RiskAreaReorderList: ko.observableArray(),
        RiskAreaReorderListDup: ko.observableArray(),
        RiskFactorReorderList: ko.observableArray(),
        RiskFactorReorderListDup: ko.observableArray(),
        RiskSubFactorReorderList: ko.observableArray(),
        RiskSubFactorReorderListDup: ko.observableArray(),
        FactorAssessmentTypeList: ko.observableArray(),
        editableRiskFactor: ko.observable(),
        trclick: trclick,
        RiskSubFactorsList: ko.observableArray(),
        RiskFactorId: ko.observable(),
        AMLRiskLevel: ko.observable(),
        SANCRiskLevel: ko.observable(),
        editableRiskSubFactor: ko.observable(),
        AMLRiskLevelDrpDwnList: ko.observableArray(),
        RiskScoreDrpDwnList: ko.observableArray(),
        SanctionRiskLevelDrpDwnList: ko.observableArray(),
        rsfPopUpTitle: ko.observable(),
        valueAML: ko.observable(),
        valueSANC: ko.observable(),
        valueAMLScore: ko.observable(),
        valueSANCScore: ko.observable(),
        ControlsAccess: ko.observable(false),
        AssessmentTypeFactor: ko.observable(),
        AssessmentTypeSubFactor: ko.observable(),
        AssessmentTypeSubFactorParent: ko.observable(),
        AssessmentTypeSubFactorDisabled: ko.observable(true),
        AssessmentTypeFactorDisabled: ko.observable(true),
        AssessmentTypeAreaDisabled: ko.observable(true),
        CurrentRiskAreaId: ko.observable(),
        CurrentRiskAreaType: ko.observable(),
        AMLNumbering: ko.observable(),
        SANCNumbering: ko.observable(),
        AMLRSFNumbering: ko.observable(),
        SANCRSFNumbering: ko.observable(),
        AMLScoreVisible: ko.observable(false),
        SANCScoreVisible: ko.observable(false),
        SelectedAssessmentType: ko.observableArray([]),
        SelectedLanguageType: ko.observableArray([]),
        // RiskScoreDrpDwnList: ko.observableArray(),
        AssessmentTypeList: ko.observable(),//addedd to host the assessment type data
        CurrentScreenName: ko.observable(''),
        setTriggerAttach: true,
        RiskAreaTypeUI: ko.observable(),
        editableResponseType: ko.observable(),
        WeightedAverageType: ko.observable(false),
        ActionChanged: ActionChanged,
        SelectedAssessmentTypeFactor: ko.observableArray([]),
        ObjGeneralSettings: ObjGeneralSettings,
        LanguageList: ko.observableArray(),
        //GetAllSubFactor_RiskId: GetAllSubFactor_RiskId,
        RiskAreaSubList: ko.observableArray(),
        LanguageDropdownVisible: ko.observable(true),
        editableResponseTypes: ko.observableArray(),
        isGlobalFlag: ko.observable(),
        AssessmentType: ko.observable(),
        AssessmentTypeColumnList: ko.observableArray(),
        FactorWeightedAverageType: ko.observable(),
        assessmentSelected: ko.observable(false),
        editableResponseTypesForFactor: ko.observableArray(),
        LanguageddFactorVisible: ko.observable(true),
        SelectedLanguageFactorType: ko.observableArray([]),
        FactorRiskAreaList: ko.observableArray(),
        ObjFactorRiskAreaList: ko.observableArray(),
        UpdateRiskAreaLangList: ko.observableArray(),
        SelectedLanguageSubFactorType: ko.observableArray([]),
        SubFactorRiskAreaList: ko.observableArray(),//sub factor
        SubFactorAddAreaList: ko.observableArray(),//sub factor
        InherentRiskLevelList: ko.observableArray(),
        InherentRiskLevelListDup: ko.observableArray(),
        calculationFactor: ko.observable(true),
        SimpleAverageType: ko.observable(false),
        SelectSubFactors: SelectSubFactors,
        SelectSubFactor: SelectSubFactor,
        SelectAll: SelectAll,
        RiskAreaDetailsList: ko.observableArray([]),
        ConfigureSurvey: ConfigureSurvey,
        SelectedAreas: ko.observableArray(),
        SelectedBuId: ko.observable(),
        ClickedSurveyProfileId: ko.observable(),
        BulkFlag: ko.observable(),
        BulkFlagLength: ko.observable(),
        closeQuestionnaireSCViewModel: closeQuestionnaireSCViewModel
    };

    return HmViewModel;


    var GetAllRiskAreaAjax = {};
    var GetAllRiskFactorAjax = {};
    var AddRiskAreaAjax = {};
    var GetAllRiskSubFactorsAjax = {};
    var isEdit, isRsfEdit = false;


    function activate(data) {
        try {

            //$('#adddivtab').on('click', function () {
            //});
            HmViewModel.RiskAreaDetailsList([]);
            HmViewModel.SelectedAreas(data.SelectedAreas);
            HmViewModel.SelectedBuId(data.SelectedBuId);
            HmViewModel.BulkFlag(data.BulkFlag);
            HmViewModel.BulkFlagLength(data.BulkFlagLength)
            HmViewModel.ClickedSurveyProfileId(data.ClickedSurveyProfileId);
            $('#Quant_select_all_chckbox').prop('checked', false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {
            if (appsecurity.WriteAccess()) {
                HmViewModel.ControlsAccess(true);
            }
            else {
                HmViewModel.ControlsAccess(false);
            }
            GetAllDetails();

            var url = window.location.pathname;
            HmViewModel.CurrentScreenName(url.substring(url.lastIndexOf('/') + 1));
            $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');
            $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(4)).addClass('active');
            GetAllAssessmentTypes();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            GetAllRiskAreaAjax = {
                url: "/api/Configuration/GetSelectedRiskAreas",
                type: "POST",
                headers: headers,
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    RiskAreaIds: HmViewModel.SelectedAreas,
                    AreaType: "QTDR",
                    BuId: HmViewModel.SelectedBuId,
                    SurveyProfileId: HmViewModel.ClickedSurveyProfileId
                })
            };

            $(document).on('click', '#adddivtab li', function (event) {
                TabClick(event);
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    };

    function GetAllDetails() {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            GetAllRiskAreaDetails = {
                url: "/api/Configuration/GetAllRiskAreaDetails",
                type: "POST",
                headers: headers,
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    RiskAreaIds: HmViewModel.SelectedAreas,
                    BuId: HmViewModel.SelectedBuId,
                    SurveyProfileId: HmViewModel.ClickedSurveyProfileId
                })
            };

            $.ajax(GetAllRiskAreaDetails)
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreas() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                $('#loadingImgMappingFetch').show();
                if (jsonResult != null && jsonResult[0].RiskAreaId != null) {

                    var mappedRiskAreaDetailsList = $.map(jsonResult, function (result) {
                        return new RiskAreaDetailsModel(result);
                    });
                    HmViewModel.RiskAreaDetailsList(mappedRiskAreaDetailsList);
                }

                GetAllRiskAreas(GetAllRiskAreaAjax);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in RiskAreaAndFactors.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        };
    }

    function ActionChanged(data, event) {
        try {
            BindDynamicHtmlForDropDowns();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionChanged() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function SelectSubFactors(data, event) {
        try {


            for (i = 0; i < HmViewModel.RiskAreaDetailsList().length; i++) {
                if (data.RiskFactorId() === HmViewModel.RiskAreaDetailsList()[i].RiskFactorId()) {
                    if (event.currentTarget.checked) {
                        HmViewModel.RiskAreaDetailsList()[i].IsApplicable(true);
                        HmViewModel.RiskAreaDetailsList()[i].selected(true);
                    }
                    else {
                        HmViewModel.RiskAreaDetailsList()[i].IsApplicable(false);
                        HmViewModel.RiskAreaDetailsList()[i].selected(false);
                    }
                }
            }
            for (j = 0; j < HmViewModel.RiskSubFactorsList().length; j++) {
                if (data.RiskFactorId() === HmViewModel.RiskSubFactorsList()[j].RiskFactorId()) {
                    if (event.currentTarget.checked) {
                        HmViewModel.RiskSubFactorsList()[j].selected(true);
                        //HmViewModel.RiskSubFactorsList()[j].FactorSelected(true);
                    }
                    else {
                        HmViewModel.RiskSubFactorsList()[j].selected(false);
                        //HmViewModel.RiskSubFactorsList()[j].FactorSelected(false);
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectSubFactors() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function SelectSubFactor(data, event) {
        try {

            for (i = 0; i < HmViewModel.RiskAreaDetailsList().length; i++) {
                if (data.RiskSubfactorId() == HmViewModel.RiskAreaDetailsList()[i].RiskSubFactorId()) {
                    if (data.selected()) {
                        HmViewModel.RiskAreaDetailsList()[i].IsApplicable(true);
                    }
                    else {
                        HmViewModel.RiskAreaDetailsList()[i].IsApplicable(false);
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectSubFactors() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }


    function SelectAll(data,event) {
        try {


            if (event.currentTarget.checked === true) {

                HmViewModel.selectAllMappingFlag(true);
            }
            else {
                HmViewModel.selectAllMappingFlag(false);
            }

            for (l = 0; l < HmViewModel.RiskFactorList().length; l++) {
                if (event.currentTarget.checked === true) {
                    HmViewModel.RiskFactorList()[l].FactorSelected(true);

                }
                else {
                    HmViewModel.RiskFactorList()[l].FactorSelected(false);

                }
            }

            for (i = 0; i < HmViewModel.RiskAreaDetailsList().length; i++) {
                if (event.currentTarget.checked === true) {
                    HmViewModel.RiskAreaDetailsList()[i].IsApplicable(true);
                }
                else {
                    HmViewModel.RiskAreaDetailsList()[i].IsApplicable(false);
                }

            }



            for (j = 0; j < HmViewModel.RiskSubFactorsList().length; j++) {

                if (event.currentTarget.checked === true) {
                    HmViewModel.RiskSubFactorsList()[j].selected(true);
                }
                else {
                    HmViewModel.RiskSubFactorsList()[j].selected(false);
                }

            }




            //for (i = 0; i < HmViewModel.RiskAreaList().length; i++) {

            //    var RiskAreaId = HmViewModel.RiskAreaList()[i].RiskAreaId();
            //    GetAllSubFactor_RiskId(RiskAreaId);

            //}


            //for (i = 0; i < HmViewModel.RiskAreaDetailsList().length; i++) {

            //    HmViewModel.RiskAreaDetailsList()[i].selected(true);

            //}



              }


        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectSubFactors() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //function SelectAll(data, event) {
    //    try {


    //        for (i = 0; i < HmViewModel.RiskAreaDetailsList().length; i++) {


    //                    HmViewModel.RiskAreaDetailsList()[i].IsApplicable(true);


    //                    HmViewModel.RiskAreaDetailsList()[i].IsApplicable(false);


    //        }
    //        for (j = 0; j < HmViewModel.RiskSubFactorsList().length; j++) {
    //            if (data.RiskFactorId() == HmViewModel.RiskSubFactorsList()[j].RiskFactorId()) {
    //                if (data.FactorSelected()) {
    //                    HmViewModel.RiskSubFactorsList()[j].selected(true);
    //                }
    //                else {
    //                    HmViewModel.RiskSubFactorsList()[j].selected(false);
    //                }
    //            }
    //        }
    //    }
    //    catch (e) {
    //        var msg = 'Exception: ' + e + ' | Source: SelectSubFactors() method in RiskArea&Factor.js';
    //        logger.logMessage(msg);
    //    }
    //}

    function closeQuestionnaireSCViewModel()
    {
        try {
            $("#riskAreaTab").hide();
        }
        catch (e)
        {
            var msg = 'Exception: ' + e + ' | Source: closeQuestionnaireSCViewModel() method in QuantitativeSurveySetup.js';
            logger.logMessage(msg);
        }
    }

    function BindDynamicHtmlForDropDowns() {
        try {
            var selectedassessments = HmViewModel.SelectedAssessmentTypeSubFactor();
            $('#DynamicScoreDiv').empty();
            var DynamicHTMl = "";
            for (var j = 0; j < HmViewModel.SelectedAssessmentTypeSubFactor().length; j++) {
                for (var i = 0; i < HmViewModel.AssessmentTypeList().length; i++) {
                    if (parseInt(HmViewModel.SelectedAssessmentTypeSubFactor()[j]) == HmViewModel.AssessmentTypeList()[i].AssessmentId()) {

                        DynamicHTMl += '<div class="form-group" id="appSubfactor">' +
                                           '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">' + HmViewModel.AssessmentTypeList()[i].AssessmentName() + ' Score</label>' +
                                           '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                                            '<select id="' + HmViewModel.AssessmentTypeList()[i].AssessmentId() + '" data-bind="foreach:{data: InherentRiskLevelList, as: \'List1\'}" class="form-control">' +
                                            '<!-- ko if: (List1.AssessmentTypeId ==' + parseInt(HmViewModel.SelectedAssessmentTypeSubFactor()[j]) + ')-->' +
                                           '<optgroup data-bind="attr: {label: RiskLevelName}, foreach: MappedRiskLevels">' +
                                            '<option data-bind="text: RiskLevelDescription,value:RiskLevelId"></option>' +
                                            '</optgroup>' +
                                            '<!--/ko -->' +
                                           '</select>' +
                                           '</div>' +
                                           '</div>';
                    }
                }
            }
            document.getElementById('DynamicScoreDiv').innerHTML = DynamicHTMl
            ko.cleanNode(document.getElementById('DynamicScoreDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicScoreDiv"));

            if (HmViewModel.SelectedLanguageSubFactorType().length > 2 || selectedassessments.length > 2) {
                $("#frmSubFactorScroll").css({ "height": "33rem", "overflow-y": "scroll", "overflow-x": "hidden" });
            } else {
                $("#frmSubFactorScroll").removeAttr("Style");
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForDropDowns() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //Function to bind the applicability Dropdown Dynamically starts here
    function GetAllAssessmentTypes() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAssessmentTypes",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(function (jsonResult, error) {
                HmViewModel.AssessmentTypeList([]);
                if (jsonResult != null) {


                    var MappedAssessmentList = $.map(jsonResult, function (result) {
                        return new AssessmentListModel(result);
                    });
                    HmViewModel.AssessmentTypeList(MappedAssessmentList);
                }
            })
            .fail(function (jsonResult, error) {
                logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(HmViewModel), true);
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in RiskAreasfactors.js';
            logger.logMessage(msg);
        }
    }
    //Function to bind the applicability Dropdown ends here

    //To disable the transactions checkbox - survey launch flag
    function GetAllSurveyType(GetAllSurveyTypeAjax) {
        try {
            $.ajax(GetAllSurveyTypeAjax)
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllSurveyType() in RisksAreasfactors.js';
            logger.logMessage(msg);

        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var mappedSurvey = $.map(jsonResult, function (result) {
                        var SurveyModelObj = new SurveyModel(result);
                        addNewDivTab(SurveyModelObj);
                        return SurveyModelObj;
                    });
                    HmViewModel.SurveyDetailsList(mappedSurvey);
                    for (i = 0; i < HmViewModel.SurveyDetailsList().length; i++)
                        if (HmViewModel.SurveyDetailsList()[i].surveyType() == "QTDR") {
                            if (HmViewModel.SurveyDetailsList()[i].SurveyStatus()) {
                                $('#responseapplicability3').attr('disabled', true);
                            }
                            else {
                                $('#responseapplicability3').attr('disabled', false);
                            }
                        }

                }
                else
                    logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllSurveyType() in RisksAreasfactors.js';
                logger.logMessage(msg);

            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllSurveyType() method in RisksAreasfactors.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllSurveyType() method in RisksAreasfactors.js';
                logger.logMessage(msg);
            }
        }
    }

    function RiskAreaSubFactor(item) {
        try {
            var self = this;
            self.RiskAreaName = $('#subfactorname' + item).val();
            self.LanguageType = item;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaSubFactor() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    };

    function AddDynamicSubFactorElements(item) {
        try {
            $('#DynamicSubFactorDiv').empty();
            var ResponseHTMl = "";

            $.each(item, function (key, value) {
                ResponseHTMl += '<div class="form-group">' +
                                           '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">Sub-Factor Name (' + GetLanguageName(value.LanguageType) + ')</label>' +
                                            '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                                               '<input id="subfactorname' + value.LanguageType + '" class="form-control" data-bind="value: SubFactorRiskAreaList().RiskSubfactorName" type="text" />' +
                                           '</div>' +
                                        '</div>';
            });

            document.getElementById('DynamicSubFactorDiv').innerHTML = ResponseHTMl;
            ko.cleanNode(document.getElementById('DynamicSubFactorDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicSubFactorDiv"));

            if (item.length > 2) {
                $("#frmSubFactorScroll").css({ "height": "29rem", "overflow-y": "scroll", "overflow-x": "hidden" });
            } else {
                $('#frmSubFactorScroll').removeAttr("style");
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AddDynamicSubFactorElements() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function BindDynamicHtmlForDropDownsEdit(data) {
        try {
            var DynamicHTMl = "";
            var arr = [];
            for (var k = 0; k < data.length; k++) {
                var splitID = data[k].split(',')

                for (var g = 0; g < HmViewModel.AssessmentTypeList().length; g++) {
                    if (parseInt(splitID[0]) == HmViewModel.AssessmentTypeList()[g].AssessmentId()) {
                        DynamicHTMl += '<div class="form-group" id="appSubfactor_RiskLevel">' +
                                           '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">' + HmViewModel.AssessmentTypeList()[g].AssessmentName() + ' Score</label>' +
                                           '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                            '<select id="' + HmViewModel.AssessmentTypeList()[g].AssessmentId() + ' "data-bind="foreach:{data: InherentRiskLevelList, as: \'List1\'}" class="form-control">' +
                            '<!-- ko if: (List1.AssessmentTypeId ==' + splitID[0] + ')-->' +
                                           '<optgroup data-bind="attr: {label: RiskLevelName}, foreach: MappedRiskLevels">' +
                                            '<option data-bind="text: RiskLevelDescription,value:RiskLevelId"></option>' +
                                            '</optgroup>' +
                                            '<!--/ko -->' +
                                           '</select>' +
                                           //'<select id="' + HmViewModel.AssessmentTypeList()[g].AssessmentId() + '" data-bind="options: $root.RiskScoreDrpDwnList,optionsText :\'DisplayText\', optionsValue: \'Id\'" class="form-control"></select>' +
                                           '</div>' +
                                           '</div>';

                    }
                }

            }


            document.getElementById('DynamicScoreDiv').innerHTML = DynamicHTMl
            ko.cleanNode(document.getElementById('DynamicScoreDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicScoreDiv"));
            for (var k = 0; k < data.length; k++) {
                var splitID = data[k].split(',')
                $('#' + parseInt(splitID[0])).val(parseInt(splitID[1]))
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForDropDownsEdit() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function AddDynamicFactorElements(item) {
        try {
            $('#DynamicRiskFactorDiv').empty();
            var QuestionNameHTMl = "";

            if (item.length > 2) {
                $('#DynamicRiskFactorDiv').css({
                    "margin-left": ".7rem", "margin-bottom": "1rem",
                    "overflow-y": "scroll", "overflow-x": "hidden", "height": "11rem",
                    "border": "1px solid lightgray",
                    "padding-top": "5px !important",
                    "padding-bottom": "5px !important",
                    "padding-top": "1rem"
                });
            } else {
                $('#DynamicRiskFactorDiv').removeAttr("Style");
            }

            $.each(item, function (key, value) {
                QuestionNameHTMl += '<div class="form-group">' +
                                           '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3">Risk Factor Name (' + GetLanguageName(value.LanguageType) + ')</label>' +
                                           '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                                               '<input id="questionname' + value.LanguageType + '" class="form-control" data-bind="value: FactorRiskAreaList().RiskAreaName" type="text" />' +
                                           '</div>' +
                                        '</div>';
            });

            document.getElementById('DynamicRiskFactorDiv').innerHTML = QuestionNameHTMl;
            ko.cleanNode(document.getElementById('DynamicRiskFactorDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicRiskFactorDiv"));
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AddDynamicFactorElements() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function RiskAreaFactor(item) {
        try {
            var self = this;
            self.RiskAreaName = $('#questionname' + item).val();
            self.LanguageType = item;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    };

    //tblriskfactor expand collapse method
    function trclick(data, event) {
        try {
            var tr = $(event.currentTarget).closest('tr');
            var row = RfTableObj.row(tr);
            checkExpandedRow(row, false);
            if (row.child.isShown()) {
                //close the open row
                row.child.hide();
                tr.removeClass('shown');
            }
            else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');

                ko.applyBindingsToNode($('#subfactor').find('tbody').get(0), { foreach: HmViewModel.RiskSubFactorsList }, HmViewModel);
                if (HmViewModel.ControlsAccess())
                    ko.applyBindingsToNode($('#btnsfReorder'), { disabled: true, click: HmViewModel.OpenRiskSubFactorOrderPopup }, HmViewModel);
                ko.applyBindingsToNode($('#addSubFactorBtn'), { click: HmViewModel.addRiskSubFactorFunctionality }, data);
                RfSubFactorTableObj = $("#subfactor").DataTable({
                    "bResponsive": true,
                    "bPaginate": true,
                    "order": [],
                    "aaSorting": [],

                    "aoColumnDefs": [{
                        "aTargets": [0],
                        "order": [],
                        "bVisible": false
                    }, {
                        "aTargets": [1],
                        "order": [],
                        "bSortable": false
                    },
                    //{
                    //    "aTargets": [2],
                    //    "order": [],
                    //    "bSortable": false,

                    //},
                    //{
                    //    "aTargets": [3],
                    //    "order": [],
                    //    "bSortable": false,

                    //},
                    //{
                    //    "aTargets": [4],
                    //    "order": [],
                    //    "bSortable": false,
                    //    "sClass": "text-center",
                    //    "bVisible": (HmViewModel.ControlsAccess())
                    //}
                    ]
                })
                var rows = $("#subfactor").dataTable().fnGetNodes();
                var cells = [];
                for (var i = 0; i < rows.length; i++) {
                    // Get HTML of 3rd column (for example)
                    var x = $(rows[i]).find("td:eq(3)").html();
                    var y = x.replace('|', '<br/>');
                    $(rows[i]).find("td:eq(3)").html(y);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: trclick() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function checkExpandedRow(row, isPaginating) {
        try {
            var currentRowIndex;
            var rowsInTable = $('#tblRiskFactor').find('tr');
            if (isPaginating)
                currentRowIndex = -1;
            else
                currentRowIndex = row.index();
            var info = RfTableObj.page.info();
            for (var i = 1, j = (rowsInTable.length) ; i < j; i++) {
                //if (currentRowIndex != (i - 1)) {
                var tr = $('#tblRiskFactor').find('tr').get(i);
                if (RfTableObj.row(tr).index() != row.index()) {
                    var tableRowIndex = (info.page * info.length) + (i - 1);

                    if ((RfTableObj.row(tableRowIndex).child() != undefined) && (RfTableObj.row(tableRowIndex).child.isShown())) {
                        RfTableObj.row(tableRowIndex).child.remove();
                        tr.removeAttribute('class', 'shown')
                        j = $('#tblRiskFactor').find('tr').length;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: checkExpandedRow() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    // for adding tblsubfactor in the expanded row
    function format(data) {
        try {
            var X = 3;
            var Y = 3;

            HmViewModel.RiskFactorId(data[1]);
            HmViewModel.AssessmentTypeSubFactorParent(data[5]);
            GetAllRiskSubFactorsAjax = {

                url: "/api/Configuration/GetRiskSubFactorByFactorAndProfile",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { 'RiskFactorId': HmViewModel.RiskFactorId(), 'sp_uid': HmViewModel.ClickedSurveyProfileId }
            };
            GetAllRiskSubFactors(GetAllRiskSubFactorsAjax);

            var SfHtml = '<div class="child-active" style="margin-left:3em;">' +
                            '<div class="panel panel-success panel-margin">' +
                                '<div class="panel-heading">' +
                                    '<h5 class="panel-title riskFactorCellPanel">Sub-Factors';
            SfHtml += '</h5>' +
        '</div>' +
    '</div>' +
    '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subfactor-margin">' +
    '<table id="subfactor" class="dataTable table-bordered" cellspacing="0">' +
        '<thead>' +
            '<tr>' +
                '<th style="display:none">Subfactor ID</th>' +
                '<th style="display:none">Risk Mapping</th>' +
                '<th>Sub-Factor Name</th>' +
                '<th class="site_name"  >Select</th>' +
                '<th style="display:none">factor ID</th>' +
            '</tr>' +
        '</thead>' +
        '<tbody data-bind="foreach: RiskSubFactorsList">' +
            '<tr>' +
                '<td style="display:none" data-bind="text: RiskSubfactorId"></td>' +
                '<td style="display:none" data-bind="text: RiskMapping"></td>' +
                '<td data-bind="text: RiskSubfactorName"></td>' +
                '<td class="text-center"><label class="cc-checkbox"><input type="checkbox" data-bind="checked: selected, event: {change : $root.SelectSubFactor}" /><span class="cc-facet-result-text tag-text"></span></label></td>' +
            '<td style="display:none" data-bind="text: RiskFactorId"></td>' +
            '</tr>' +
        '</tbody>' +
    '</table>' +
    '</div>';

            return SfHtml;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: format() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    // get all subfactor method
    function GetAllRiskSubFactors(GetAllRiskSubFactorsAjax) {
        try {

            $.ajax(GetAllRiskSubFactorsAjax)
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllRiskSubFactors() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                HmViewModel.SelectedLanguageSubFactorType([]);
                HmViewModel.SubFactorRiskAreaList([]);

                HmViewModel.RiskSubFactorsList([]);

                var mappedRiskSubFactors = $.map(jsonResult, function (result) {
                    return new RiskSubFactorModel(result);
                });

                tableObj = $('#subfactor').DataTable();
                tableObj.destroy();
                $("#subfactor tbody tr").remove();
                HmViewModel.RiskSubFactorsList(mappedRiskSubFactors);

                ko.utils.arrayForEach(HmViewModel.RiskSubFactorsList(), function (AgainItem) {
                    if (HmViewModel.BulkFlag() && HmViewModel.BulkFlagLength() > 1) {
                        AgainItem.selected(false);
                    }
                });

                RfSubFactorTableObj = $("#subfactor").DataTable({
                    "bResponsive": true,
                    "bPaginate": true,
                    "order": [],
                    "aaSorting": [],

                    "aoColumnDefs": [{
                        "aTargets": [0],
                        "order": [],
                        "bVisible": false
                    }, {
                        "aTargets": [1],
                        "order": [],
                        "bSortable": true
                    },
                    ]
                })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskSubFactors() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in GetAllRiskSubFactors() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxfail in GetAllRiskSubFactors() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
    }

    function GetAllInherentLevels() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAllInherentLevels",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AssessmentId: 0 }
            })
                       .success(function (jsonResult, Error) {
                           if (jsonResult == 0 || jsonResult == null) {
                               document.getElementById("akshay").innerHTML = "Inherent Risk Levels are not yet configured for this profile of assessment."
                           }
                           else {
                               var mappedIRSData = $.map(jsonResult, function (result) {
                                   return new RiskLevelModel(result);
                               });
                               var mappedIRSDataDup = $.map(jsonResult, function (result) {
                                   return new RiskLevelModel(result);
                               });
                               HmViewModel.InherentRiskLevelListDup(mappedIRSDataDup);
                               HmViewModel.InherentRiskLevelList(mappedIRSData);
                           }
                       })
                       .fail(function (jsonResult, log) {
                           if (error.status == 401) {
                               app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                   .then(function (option) {
                                       if (option == "OK")
                                           navigation.unauthorized();
                                   })
                           }
                           else {
                               var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllInherentLevels() method in RiskArea&Factor.js';
                               logger.logMessage(msg);
                           }
                       });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllInherentLevels() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function AddDynamicElements(item) {
        //var selectedLanguage = HmViewModel.SelectedLanguageType();
        $('#DynamicRiskAreaNameDiv').empty();
        var RiskAreaNameHTMl = "";

        $('#DynamicCommentsDiv').empty();
        var CommentsHTMl = "";

        $.each(item, function (key, value) {
            RiskAreaNameHTMl += '<div class="form-group">' +
                                      '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">Risk Area Name (' + GetLanguageName(value.LanguageType) + ')</label>' +
                                      '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                                          '<input id="riskareaname' + value.LanguageType + '" class="form-control" data-bind="value: RiskAreaSubList().RiskAreaName" type="text" />' +
                                      '</div>' +
                                   '</div>';

            CommentsHTMl += '<div class="form-group">' +
                            '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">Comments (' + GetLanguageName(value.LanguageType) + ')</label>' +
                            '<div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">' +
                               '<textarea id="EditRaTextArea' + value.LanguageType + '" class="form-control" rows="5" data-bind="value:RiskAreaSubList().RiskAreaNotes" name="Notes" ></textarea>' +
                            '</div>' +
                            '</div>';
        });

        document.getElementById('DynamicRiskAreaNameDiv').innerHTML = RiskAreaNameHTMl;
        ko.cleanNode(document.getElementById('DynamicRiskAreaNameDiv'));
        ko.applyBindings(HmViewModel, document.getElementById("DynamicRiskAreaNameDiv"));

        document.getElementById('DynamicCommentsDiv').innerHTML = CommentsHTMl;
        ko.cleanNode(document.getElementById('DynamicCommentsDiv'));
        ko.applyBindings(HmViewModel, document.getElementById("DynamicCommentsDiv"));


    }

    function RiskArea(item) {
        try {
            var self = this;
            self.RiskAreaName = $('#riskareaname' + item).val();
            self.RiskAreaNotes = $('#EditRaTextArea' + item).val();
            self.LanguageType = item;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskArea() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    };

    function addNewDivTab(data) {
        try {
            $("#riskAreaTab").show();
            $('#riskAreaTab ul').append(
                '<li id="' + data.RiskAreaId() + '"><a id="' + data.RiskAreaId() + '" href="#adddivtabbody">' + data.RiskAreaName() + '</a></li>'
                );
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addNewDivTab() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function TabClick(event) {
        try {
            HmViewModel.SelectedLanguageSubFactorType([]);
            HmViewModel.SubFactorRiskAreaList([]);
            $("#adddivtabbody").show();
            var ClickedRiskAreaId = event.currentTarget.firstChild.attributes['id'].value;
            $('#adddivtab li').removeClass('active');
            $('#'+ClickedRiskAreaId).addClass('active');
            HmViewModel.CurrentRiskAreaId('');
            HmViewModel.CurrentRiskAreaId(ClickedRiskAreaId);
            for (var i = 0, j = HmViewModel.RiskAreaList().length; i < j; i++) {
                if (HmViewModel.RiskAreaList()[i].RiskAreaId() == ClickedRiskAreaId) {
                    HmViewModel.CurrentRiskAreaType(HmViewModel.RiskAreaList()[i].MappedAssessmentType());
                    GetFactorTabData(HmViewModel.RiskAreaList()[i])
                    GetRiskFactors(ClickedRiskAreaId);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: TabClick() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function GetFactorTabData(data) {
        try {
            var Assessment = "";
            for (var k = 0; k < HmViewModel.AssessmentTypeList().length ; k++) {
                for (var f = 0; f < data.MappedAssessmentType().length; f++) {
                    if (parseInt(HmViewModel.AssessmentTypeList()[k].AssessmentId()) == data.MappedAssessmentType()[f].ID) {

                        if (k == 0)
                            Assessment += HmViewModel.AssessmentTypeList()[k].AssessmentName();
                        else {
                            if (Assessment == "") {
                                Assessment += HmViewModel.AssessmentTypeList()[k].AssessmentName();
                            }
                            else {
                                Assessment += ", " + HmViewModel.AssessmentTypeList()[k].AssessmentName();
                            }
                        }
                    }
                }
            }
            var RiskAreaType = "";
            if (data.RiskAreaType() == "SANC")
                RiskAreaType = "Sanctions";
            else
                RiskAreaType = data.RiskAreaType();
            var HtmlBody =

    '<div class="page-header sub padding-custom">' +
        '<h5>' +

            //'<i class="title-icon fa fa-file-text"></i>' +
            'Quantitative Risk Factors';

            HtmlBody += '</h5>' +
    '</div>' +
    '<table id="tblRiskFactor" class="dataTable table-bordered no-footer" cellspacing="0">' +
        '<thead>' +
            '<tr>' +
                '<th class="site_name"></th>' +
                '<th class="site_name" style="display:none" >Risk Factor Id</th>' +
                 '<th class="site_name">Risk Factor Name</th>' +
                '<th class="site_name"  >Select</th>' +


                //'<th class="parent_action">Actions</th>' +
            '</tr>' +
        '</thead>' +// +getfactors(jsonResult[i].RiskAreaId, name)+Getbody()+
        '<tbody data-bind="foreach:RiskFactorList">' +
            '<tr>' +
                '<td class="details-control action-bgcolor"><div style="display:none"></div></td>' +
                '<td style="display:none" data-bind="text: RiskFactorId"></td>' +
                '<td data-bind="text: RiskFactorName"></td>' +
               '<td class="text-center"><label class="cc-checkbox"><input type="checkbox" data-bind="checked: FactorSelected, event: {change : $root.SelectSubFactors}" /><span class="cc-facet-result-text tag-text"></span></label></td>'
            '</tr>' +
        '</tbody>' +
    '</table>';
            document.getElementById('adddivtabbody').innerHTML = '';
            document.getElementById('adddivtabbody').innerHTML = HtmlBody;

            var element = $('#adddivtabbody')[0];
            ko.cleanNode(element);
            ko.applyBindings(HmViewModel, document.getElementById('adddivtabbody'));

            //ko.applyBindingsToNode($('#tblRiskFactor').find('tbody').get(0), { foreach: HmViewModel.RiskFactorList }, HmViewModel);
            //ko.applyBindingsToNode($('#btnAddRf'), { disabled: true, click: HmViewModel.ShowFactorPopUp }, HmViewModel);
            var selected = new RiskAreaModel({ RiskAreaId: data.RiskAreaId(), AssessmentIdList: data.MappedAssessmentType(), RiskAreaName: data.RiskAreaName(), RiskAreaType: data.RiskAreaType(), RiskAreaNotes: data.RiskAreaNotes(), RiskAreaSubList: data.RiskAreaSubList() });
            HmViewModel.SelectedRiskAreaDetails(selected);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetFactorTabData() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function CheckforSelectedRiskAreas(list) {
        try {

            HmViewModel.RiskAreaList(list);


            var SelectedAreas = HmViewModel.SelectedAreas();
            for (i = 0; i < SelectedAreas.length; i++) {
                if (SelectedAreas[i]) {

                }

            }
        }
        catch (e) {

        }
    }

    function GetAllRiskAreas() {
        try {

            $.ajax(GetAllRiskAreaAjax)
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreas() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null && jsonResult[0].RiskAreaId != null) {
                    $('#adddivtab').empty();
                    HmViewModel.RiskAreaList([]);
                    HmViewModel.RiskAreaReorderListDup([]);
                    HmViewModel.RiskAreaReorderList([]);
                    HmViewModel.RiskAreaSortOrder(0);
                    HmViewModel.RiskAreaSubList([]);


                    var mappedRiskAreaList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaModel(result);
                        addNewDivTab(RiskAreaModelObj);
                        return RiskAreaModelObj;
                    });
                    HmViewModel.RiskAreaSortOrder(0);

                    // scrollableTabs();
                    CheckforSelectedRiskAreas(mappedRiskAreaList)
                    $("#riskAreaTab").tabs();
                    $('#riskAreaTab').tabs('refresh');
                    $('#riskAreaTab').tabs({ active: 0 });
                    $($('#riskAreaTab li').get(0)).trigger('click');
                    scrollableTabs();
                }
                else if (jsonResult[0].RiskAreaId == 0 && jsonResult[0].RiskAreaName == null) {
                    $('#error').show();
                    $('#adddivtab').empty();
                    $('#adddivtabbody').empty();
                    HmViewModel.RiskAreaList([]);
                    HmViewModel.RiskAreaReorderListDup([]);
                    HmViewModel.RiskAreaReorderList([]);
                    HmViewModel.RiskAreaSortOrder(0);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in RiskAreaAndFactors.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        };
    }







    function GetRiskFactors(RiskAreaId) {
        try {
            HmViewModel.RiskAreaId(RiskAreaId);
            GetAllRiskFactorAjax = {
                url: "/api/Configuration/GetAllRiskfactorByAreaAndProfile",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { "RiskAreaId": RiskAreaId, "AssessmentType": 'QTDR', "sp_uid": HmViewModel.ClickedSurveyProfileId }
            };
            GetAllRiskFactor(GetAllRiskFactorAjax, RiskAreaId);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetRiskFactors() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function GetAllRiskFactor(GetAllRiskFactorAjax, RiskAreaId) {
        try {
            $.ajax(GetAllRiskFactorAjax)
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllRiskFactor() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                $('#loadingImgMappingFetch').hide();
                if (jsonResult != 'undefined' && jsonResult != null) {
                    if (jsonResult.length != 0) {
                        HmViewModel.SelectedLanguageFactorType([]),
                        HmViewModel.FactorRiskAreaList = {};
                        var mappedRiskFactors = $.map(jsonResult, function (result) {
                            return new RiskFactorModel(result);
                        });
                        HmViewModel.RiskFactorReorderList([]);
                        HmViewModel.RiskFactorReorderListDup([]);
                        HmViewModel.RiskFactorSortOrder(0);

                        tableObj = $('#tblRiskFactor').DataTable();
                        tableObj.destroy();
                        $("#tblRiskFactor tbody tr").remove();
                        HmViewModel.RiskFactorList(mappedRiskFactors);
                        ko.applyBindingsToNode($('#tblRiskFactor tbody .details-control'), { click: HmViewModel.trclick }, HmViewModel);

                        ko.utils.arrayForEach(HmViewModel.RiskFactorList(), function (AgainItem) {
                            //if (HmViewModel.BulkFlag() && HmViewModel.BulkFlagLength() > 1) {
                                //AgainItem.FactorSelected(false);
                            //}
                            //else {
                                var waffle = 0, pancake = 0;
                                ko.utils.arrayForEach(HmViewModel.RiskAreaDetailsList(), function (item) {
                                    if (item.RiskAreaId() == RiskAreaId && item.RiskFactorId() == AgainItem.RiskFactorId()) {
                                        waffle++;
                                    }
                                    if (item.RiskAreaId() == RiskAreaId && item.IsApplicable() && item.RiskFactorId() == AgainItem.RiskFactorId()) {
                                        pancake++;
                                    }
                                });
                                AgainItem.FactorSelected((waffle + pancake == 0) ? false : waffle == pancake)
                            //}
                        });

                        RfTableObj = $('#tblRiskFactor').DataTable({
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bVisible": true,


                                "sClass": "details-control"

                            }, {
                                "aTargets": [1],
                                "bVisible": false,
                                "bSortable": false

                            },
                            ]
                        });
                        $('#tblRiskFactor').DataTable().draw(false);
                    }
                    else {
                        HmViewModel.RiskFactorList([]);
                        HmViewModel.RiskFactorReorderList([]);
                        HmViewModel.RiskFactorReorderListDup([]);
                        HmViewModel.RiskFactorSortOrder(0);
                        RfTableObj = $('#tblRiskFactor').DataTable({
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bVisible": true,
                                //   "bSortable": false,

                                "sClass": "details-control"

                            }, {
                                "aTargets": [1],
                                "bVisible": false,
                                "bSortable": false

                            },
                            ]
                        });
                        $('#tblRiskFactor').DataTable().draw(false);
                    }
                }
                else {
                    HmViewModel.RiskFactorList([]);
                    HmViewModel.RiskFactorReorderList([]);
                    HmViewModel.RiskFactorReorderListDup([]);
                    HmViewModel.RiskFactorSortOrder(0);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetAllRiskFactor() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskFactor() method in RiskAreaAndFactors.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskFactor() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        }
    }

    function RiskAreaDetailsModel(item) {
        try {

            var self = this;
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskSubFactorId = ko.observable(item.RiskSubFactorId);
            self.IsApplicable = ko.observable(item.IsApplicable);
            self.selected = ko.observable(false);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaDetailsModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    };

    function RiskAreaModel(item) {
        try {
            var self = this;
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            if (item.AssessmentIdList != undefined && item.AssessmentIdList != null) {
                var MappedAssessments = $.map(item.AssessmentIdList, function (result) {
                    return new AssessmentModel(result);
                });
            }
            self.MappedAssessmentType = ko.observableArray(MappedAssessments);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
            self.AMLRank = ko.observable($('<div/>').html(item.AMLRank).text());
            self.SANCRank = ko.observable($('<div/>').html(item.SANCRank).text());
            self.RiskAreaNotes = ko.observable($('<div/>').html(item.RiskAreaNotes).text());
            self.TargetRow = ko.observable();
            self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
            self.RiskAreaSubList = ko.observableArray(item.RiskAreaSubList);
            self.selected = ko.observable(false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    };

    function AssessmentModel(item) {
        try {
            var self = this;
            if (isNaN(item)) {
                self.ID = item.ID
            }
            else {
                self.ID = item;
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorSortOrderDupModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function RiskFactorModel(item) {
        try {
            var self = this;
            self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorNameClean).text());
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.FactorSelected = ko.observable();
          //  self.allselect = ko.observable(false);
            if (item.AssessmentIdList != undefined && item.AssessmentIdList != null) {
                var MappedAssessments = $.map(item.AssessmentIdList, function (result) {
                    return new AssessmentModel(result);
                });
            }
            self.MappedAssessmentType = ko.observableArray(MappedAssessments);
            self.AMLNumbering = ko.observable($('<div/>').html(item.AMLRank).text());
            self.SANCNumbering = ko.observable($('<div/>').html(item.SANCRank).text());

            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());

            if (HmViewModel.selectAllMappingFlag()) {
                self.FactorSelected(true);
            }



         //   self.selected = ko.observable(false);
            //if (item.AssessmentType == "SANC") {
            //    self.AssessmentType = ko.observable('Sanctions');
            //}
            //else if (item.AssessmentType == "BOTH") {
            //    self.AssessmentType = ko.observable('Both');
            //}
            //else {
            //    self.AssessmentType = ko.observable(item.AssessmentType);
            //}
            self.AssessmentType = ko.observable($('<div/>').html(item.AssessmentType).text());
            self.TargetRow = ko.observable();
            self.FactorRiskAreaList = ko.observableArray(item.FactorRiskAreaList);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    };

    function RiskSubFactorModel(item) {
        try {

            var self = this;
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskSubfactorId = ko.observable(item.RiskSubfactorId);
            self.RiskSubfactorName = ko.observable($('<div/>').html(item.RiskSubfactorName).text());
            self.RiskLevel = ko.observable($('<div/>').html(item.RiskLevel).text());
            self.AssessmentType = ko.observable($('<div/>').html(item.AssessmentType).text());
            self.RiskMapping = ko.observable($('<div/>').html(item.RiskMapping).text())
            self.TargetRow = ko.observable(-1);
            self.RiskAreaSubList = ko.observableArray(item.RiskAreaSubList);
            //self.allselect = ko.observable(false);
            for (i = 0; i < HmViewModel.RiskAreaDetailsList().length; i++) {
                if (HmViewModel.RiskAreaDetailsList()[i].RiskSubFactorId() == item.RiskSubfactorId) {
                    if (HmViewModel.RiskAreaDetailsList()[i].IsApplicable())
                        self.selected = ko.observable(true);
                    else
                        self.selected = ko.observable(false);
                }
            }

            //if (HmViewModel.selectAllMappingFlag()) {
            //    self.selected(true);
            //}
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskSubFactorModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    };

    function RiskScoreModel(item) {
        try {
            var self = this;
            self.Id = ko.observable(item.Id);
            self.DisplayText = ko.observable($('<div/>').html(item.DisplayText).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskScoreModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function SurveyModel(item) {
        try {
            var self = this;
            self.SurveyName = ko.observable($('<div/>').html(item.SurveyName).text());
            self.SurveySecondName = ko.observable($('<div/>').html(item.SurveySecondName).text());
            self.surveyType = ko.observable($('<div/>').html(item.surveyType).text());
            self.SurveyStatus = ko.observable(item.SurveyStatus);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }

    function AssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
            self.AssessmentName = ko.observable(item.AssessmentName);
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
            self.Description = ko.observable($('<div/>').html(item.Description).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }

    function FilteredAssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId()).text());
            self.AssessmentName = ko.observable(item.AssessmentName());
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName()).text());
            self.Description = ko.observable($('<div/>').html(item.Description()).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: FilteredAssessmentListModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }

    function RiskLevelModel(item) {
        try {
            var self = this;
            self.RiskLevelId = item.RiskLevelId;
            self.RiskLevelName = item.RiskLevelName;
            self.RiskLevelShortText = item.RiskLevelShortText;
            self.ScoringType = item.ScoringType;
            self.LevelCount = item.RiskLevelCount;
            self.AssessmentTypeId = item.AssessmentId;
            self.MappedRiskLevels = $.map(item.RiskLevelDetailsModel, function (result) {
                return new InherentRiskLevelModel(result);
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskLevelModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }

    function InherentRiskLevelModel(item) {
        try {
            var self = this;
            self.RiskLevelId = item.RiskLevelId;
            self.RiskLevelParentId = item.RiskLevelParentId;
            self.RiskLevelcss = item.RiskLevelcss;
            self.RiskLevelComents = item.RiskLevelComents;
            self.RiskLevelDescription = item.RiskLevel + ' - ' + item.RiskLevelDescription;
            self.RiskLevel = item.RiskLevel;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InherentRiskLevelModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }
});

